module.exports = __webpack_public_path__ + "images/hellorider4dcc13cdfc0636d5ada6c19fbed63082.png";